import { ReactNode } from 'react';
import { Button, Row, Statistic } from 'antd';
import styled from 'styled-components';
import { ButtonType, ButtonShape } from 'antd/lib/button';
import Link from 'next/link';

interface HSMSTableActionsProps {
  actionTypes?: HSMSActionTypesValues[];
  statistics?: StatisticsTypesValues[];
}

interface StatisticsTypesValues {
  title: string;
  value?: string | number;
  prefix?: ReactNode;
}

interface HSMSActionTypesValues {
  id: string;
  component?: string;
  className?: string;
  type?: ButtonType;
  icon?: string;
  shape?: ButtonShape;
  dropdown?: boolean;
  dropdownIcon?: string;
  title?: string;
  show?: boolean;
  link?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: (...args: any) => void;
  loading?: boolean;
}

const TableHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .ant-statistic-content {
    font-size: 20px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const ButtonWrapper = styled.div`
  margin: 0 10px 0 10px;
`;

export const HSMSTableAction = ({ statistics, actionTypes }: HSMSTableActionsProps) => (
  <div className="table-actions">
    <TableHeaderContainer>
      <Row>
        {statistics?.map((statistic) => (
          <Statistic
            key={statistic.title + statistic.value}
            title={statistic.title}
            value={statistic.value}
            prefix={statistic.prefix}
            style={{
              margin: '0 30px',
            }}
          />
        ))}
      </Row>

      <div className="table-action-buttons">
        <ButtonContainer>
          {actionTypes?.map((actionType) => (
            <div key={actionType.id}>
              <div>
                {actionType.show === true ? (
                  <ButtonWrapper>
                    {actionType.link ? (
                      <Link href={actionType.link}>
                        <Button
                          className={actionType.className}
                          type={actionType.type}
                          size="large"
                          shape={actionType.shape}
                          icon={actionType.icon}
                          loading={actionType.loading}
                        >
                          {actionType.title}
                        </Button>
                      </Link>
                    ) : (
                      <Button
                        className={actionType.className}
                        type={actionType.type}
                        size="large"
                        shape={actionType.shape}
                        icon={actionType.icon}
                        onClick={actionType.onClick}
                        loading={actionType.loading}
                      >
                        {actionType.title}
                      </Button>
                    )}
                  </ButtonWrapper>
                ) : null}
              </div>
            </div>
          ))}
        </ButtonContainer>
      </div>
    </TableHeaderContainer>
  </div>
);
